var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"app-store-badge",style:(_vm.badgeStyle),attrs:{"aria-label":_vm.ariaLabel,"target":"_blank","rel":"noreferrer","href":_vm.href}})
}
var staticRenderFns = []

export { render, staticRenderFns }